import { t, useUiLocale } from '@/i18n/locale';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCompanion } from './CompanionContext';

export function BuddyRoomGuide({ onClose, onDress }: { onClose: () => void; onDress: () => void }) {
  useUiLocale();
  const dialog = useRef<HTMLDialogElement>(null);
  const { profile } = useCompanion();
  useEffect(() => {
    const prior = document.activeElement;
    dialog.current?.showModal();
    return () => {
      if (prior instanceof HTMLElement && prior.isConnected) prior.focus();
    };
  }, []);
  return (
    <dialog
      ref={dialog}
      className="companion-dialog"
      onCancel={onClose}
      aria-labelledby="buddy-tour-title"
    >
      <div className="flex items-start justify-between gap-3">
        <h2 id="buddy-tour-title" className="text-xl font-bold">
          {' '}
          {t('You and')} {profile.name}
        </h2>
        <button
          type="button"
          className="btn-pill-ghost"
          aria-label={t('Close buddy guide')}
          onClick={onClose}
        >
          ×
        </button>
      </div>
      <ol className="my-5 space-y-4 text-sm leading-relaxed text-ink-soft">
        <li>
          <strong className="text-ink">{t('1. Say hello.')}</strong>{' '}
          {t(
            'Tap your buddy to wave. The big space beside your buddy is where your conversation appears.',
          )}{' '}
        </li>
        <li>
          <strong className="text-ink">{t('2. Change their look.')}</strong> {t('Tap')}{' '}
          <strong>{t('Dress my buddy')}</strong>
          {t('. On a phone, open the')} <strong>{t('••• Buddy options')}</strong>{' '}
          {t('menu at the top.')}{' '}
        </li>
        <li>
          <strong className="text-ink">{t('3. Find your way back.')}</strong> {t('Tap')}{' '}
          <strong>{t('← Learn')}</strong> {t('to go home (in')}{' '}
          <strong>{t('••• Buddy options')}</strong> {t('on a phone). Tap')}{' '}
          <strong>{t('My buddy')}</strong>{' '}
          {t('at the top of Learn whenever you want to return.')}{' '}
        </li>
      </ol>
      <div className="flex flex-wrap gap-2">
        <button type="button" className="btn-pill-primary" onClick={onClose}>
          {' '}
          {t('Got it →')}{' '}
        </button>
        <button type="button" className="btn-pill-ghost" onClick={onDress}>
          {' '}
          {t('Try dressing up')}{' '}
        </button>
        <Link to="/learn" className="btn-pill-ghost" onClick={onClose}>
          {' '}
          {t('Back to Learn')}{' '}
        </Link>
      </div>
    </dialog>
  );
}
